import axios from 'axios'
import api from '@/api'

const reservationStats = {
  state: {
    data: []
  },
  getters: {
    getNumbersReservationStats: state => state.data
  },
  mutations: {
    PATIENT_RESERVATION_STATS_GET (state, payload) {
      state.data = payload
    },
  },
  actions: {
    patientsReservationStatsGet (context) {
      axios({
        method: 'post',
        url: `${api}patients/reservation-list/stats`,
      }).then(response => {
        context.commit('PATIENT_RESERVATION_STATS_GET', response.data);
      }).catch((error) => {
        console.log(error);
      })
    }
  }
};
export default reservationStats
